{
  "agreements": {
    "column": {
      "claim-option": "Opzione di richiesta",
      "currency": "Valuta",
      "description": "Descrizione",
      "more": "altro",
      "number": "N.",
      "type": "Tipo",
      "valid-from": "Valido dal",
      "valid-to": "Valido fino al"
    },
    "header": {
      "intro": "Visualizza i tuoi accordi attuali. Fai clic sul pulsante «invia richiesta» per avviare una richiesta.",
      "title": "Panoramica degli accordi"
    },
    "product": {
      "billback-rate": "Tariffa Billback / kg.",
      "code": "Codice LW",
      "name": "Prodotti"
    },
    "table": {
      "detail": {
        "contact": "Contatto:",
        "lwm-contact": "Contatto LW:",
        "download-pdf": "Scarica l'accordo in PDF"
      },
      "empty": "Nessun accordo disponibile",
      "submit-claim": "Invia richiesta"
    },
    "type": {
      "billback": "Accordo Billback QTE"
    }
  },
  "amplify": {
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6; Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$": "La password deve contenere i seguenti requisiti: Lunghezza minima password 6 caratteri; caratteri maiuscoli alfabeto inglese (A-Z); caratteri minuscoli alfabeto inglese (a-z); numeri decimali (0-9)",
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$; Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6": "2. errori di validazione rilevati: Valore in 'password' non soddisfa il vincolo: Membro deve soddisfare modello di espressione regolare: ^[\\S]+.*[\\S]+$; Valore in 'password' non soddisfa il vincolo: Membro deve avere lunghezza maggiore o uguale a 6",
    "Account recovery requires verified contact information": "Ripristino del conto richiede informazioni account verificate",
    "An account with the given email already exists.": "Un account con questa email esiste già.",
    "Apply code from MFA app": "Inserisci il codice del tuo servizio di autenticazione a più fattori.",
    "Apply code from SMS": "Ricorda questo dispositivo",
    "Back to Sign In": "Torna al Login",
    "Cancel": "Cancella",
    "Change Password": "Cambia la password",
    "Code": "Codice",
    "Confirm": "Conferma",
    "Confirm password": "Conferma password",
    "Confirm Sign In": "Conferma di login",
    "Confirm Sign Up": "Abbiamo inviato un codice di conferma al tuo indirizzo email.",
    "Confirm a Code": "Conferma un codice",
    "Confirmation Code": "Codice di conferma",
    "Create Account": "Crea account",
    "Create a new account": "Creare un nuovo account",
    "Create account": "Crea account",
    "Custom auth lambda trigger is not configured for the user pool.": "Password non può essere vuoto",
    "Email": "E-mail",
    "Email address": "Indirizzo e-mail",
    "Enter your Email address": "Inserisci il tuo indirizzo email",
    "Enter your password": "Inserisci la tua password",
    "Enter your username": "Inserisci il tuo nome utente",
    "Forgot Password": "Password dimenticata",
    "Forgot your password? ": "Password dimenticata?",
    "Have an account? ": "Già registrato?",
    "Incorrect username or password": "Nome utente o password errati",
    "Invalid code received for user": "Codice non valido ricevuto per l'utente",
    "Invalid password format": "Formato della password non valido",
    "Invalid phone number format": "Utilizzo non valido Telefonummern formattare un numero nel formato :. 12.345.678,9 mille",
    "Loading": "Caricamento in corso",
    "Lost your code? ": "Perso codice?",
    "New Password": "Nuova password",
    "No account? ": "Nessun account?",
    "Password": "Password",
    "Password attempts exceeded": "Il numero massimo di tentativi di accesso falliti è stato raggiunto",
    "Phone Number": "Numero di telefono",
    "Please confirm your password": "Si prega di confermare la password",
    "Remember this device": "Ricorda questo dispositivo",
    "Resend Code": "Codice Rispedisci",
    "Reset password": "Ripristina password?",
    "Reset your password": "Resetta password",
    "Send Code": "Invia codice",
    "Set MFA": "Imposta MFA",
    "Sign In": "Accesso",
    "Sign Out": "Esci",
    "Sign Up": "Iscriviti",
    "Sign in": "Accesso",
    "Sign in to your account": "Accedi con il tuo account a",
    "Skip": "Salta",
    "Submit": "Sottoscrivi",
    "User already exists": "Questo utente esiste già",
    "User does not exist": "L'utente non esiste",
    "User does not exist.": "Questo utente non esiste",
    "Username": "Nome utente",
    "Username cannot be empty": "Nome utente non può essere vuoto",
    "Username/client id combination not found.": "Username/client id combination not found.",
    "Verification Code": "Codice di verifica",
    "Verify": "Verifica",
    "Verify Contact": "Contatto verifica",
    "Verify Token": "Verifica"
  },
  "authentication": {
    "link-corporate": "Vai a",
    "verification_message": "Ti abbiamo inviato un codice di conferma alla tua posta.",
    "warning": {
      "requires-mfa": "Disponibile solo per utenti che hanno abilitato l'autenticazione a più fattori. È possibile impostare l'autenticazione a più fattori in "
    }
  },
  "brand": {
    "name": "Lamb Weston"
  },
  "claims": {
    "column": {
      "amount": "Importo Billback",
      "contract-no": "N. contratto",
      "description": "Descrizione",
      "info": "Info",
      "posting-date": "Data",
      "status": "Stato",
      "type": "Tipo"
    },
    "empty": "Nessuna richiesta disponibile",
    "header": {
      "intro": "Visualizza le tue richieste attuali.",
      "title": "Panoramica delle richieste inviate"
    },
    "kg": "KG",
    "new": {
      "confirm-dialog": {
        "button": "Chiudi messaggio",
        "message": "Gentile cliente, grazie per le informazioni fornite. La tua richiesta sarà esaminata e liquidata entro 3 o 4 settimane. Per qualsiasi domanda, contatta il tuo referente commerciale LW/M.",
        "title": "La tua richiesta è stata inviata"
      },
      "footer": {
        "back": "Indietro",
        "next": "Avanti",
        "submit": "Invia richiesta",
        "total-billback-amount": "Importo Billback totale",
        "total-claim-amount": "Importo totale della richiesta: ",
        "total-volume": "Volume totale: "
      },
      "items": {
        "bags": "Sacchetti",
        "billback-amount": "Importo Billback",
        "billback-rate": "Tariffa Billback",
        "boxes": "Scatole",
        "volume": "Volume"
      },
      "new-claim-button": "Invia nuova richiesta",
      "repeat-button": {
        "large1": "Vuoi avviare un'altra richiesta?",
        "large2": "Torna alla panoramica delle richieste",
        "small": "Panoramica delle richieste"
      },
      "steps": {
        "claim-details": "Compila i dettagli della richiesta",
        "claim-summary": "Riepilogo della richiesta",
        "details": {
          "agreement-details": "Dettagli dell'accordo",
          "applicant": "Richiedente",
          "currency": "Valuta:",
          "header": "Dettagli della richiesta",
          "valid-range": "Valido da-a: {from} a {to}",
          "wholesale-party": "Grossista"
        },
        "details-form": {
          "credit-reference": {
            "label": "Riferimento di credito",
            "placeholder": "Inserisci il tuo riferimento di credito"
          },
          "header": "Compila i dettagli della richiesta",
          "intro": "Seleziona i prodotti per la tua richiesta di rimborso. Ti chiediamo inoltre di indicarci il grossista presso il quale hai ordinato i tuoi prodotti.",
          "period": {
            "clear": "Cancella",
            "label": "Periodo della richiesta da - a",
            "placeholder": "Seleziona il periodo della tua richiesta"
          },
          "wholesale-party": {
            "label": "Grossista",
            "placeholder": "Inserisci il tuo grossista"
          }
        },
        "proof": {
          "attachment": {
            "label": "Fornisci la prova d'acquisto per tutti gli articoli aggiunti sopra",
            "placeholder": "Trascina e rilascia i file qui o fai clic per caricarli.  (max 25 MB) {'|'} PDF, JPG, PNG, XLSX, DOCX, MSG supportati"
          },
          "header": "Fornisci prova"
        },
        "summary": {
          "header": "Riepilogo della tua richiesta ",
          "your-billback-claim": "La tua richiesta Billback"
        }
      }
    },
    "overview": {
      "details": {
        "footer-message": "Per qualsiasi domanda, contatta il tuo referente commerciale LW EMEA.",
        "title": "Panoramica della richiesta"
      }
    },
    "search-bar": {
      "placeholder": {
        "search": "Cerca…"
      },
      "total": "Totale"
    },
    "status": {
      "failed": "Non riuscita",
      "submitted": "Inviata"
    }
  },
  "container-calculation": {
    "button": {
      "back": "Torna indietro",
      "calculate": "Calcola",
      "download": "Scarica",
      "next": "Avanti"
    },
    "download": {
      "download": "Scarica il calcolo dell'ordine ",
      "file-type": "File CSV",
      "intro": {
        "done": "Il calcolo dell'ordine del tuo container è pronto!",
        "download": "Puoi scaricare il calcolo del tuo container tramite download di un CSV."
      },
      "title": "Download del calcolo dell'ordine in CSV"
    },
    "header": {
      "intro": {
        "step-1": "Seleziona se vuoi che usiamo un foglio di carta o dei pallet per il container che hai ordinato.",
        "step-2": "Aggiungi i prodotti desiderati.",
        "step-3": "Il sistema calcolerà se ci possono essere alcuni articoli di riempimento aggiuntivi necessari per ottimizzare l'uso dello spazio del container."
      },
      "title": "Seleziona i prodotti per il container"
    },
    "load-base": {
      "pallet": "Pallet",
      "sheet": "Fogli"
    },
    "result": {
      "filled": {
        "description": "Clicca Successivo per continuare.",
        "message": "La tua attuale selezione di prodotti entra in un container, "
      },
      "initial": {
        "description": "",
        "message": "Ti aiuteremo a riempire tutto lo spazio disponibile nel container. Inserisci la quantità di pallet e clicca Calcola. Se possibile, la calcolatrice fornirà feedback su come ottimizzare lo spazio nel container."
      },
      "overfilled": {
        "description": "Ti abbiamo fornito un suggerimento basandoci sulla quantità di articolo massima che puoi accettare cliccando il pulsante arancione. Puoi sempre fare modifiche diverse cambiando la quantità di qualsiasi articolo nell’elenco. Clicca su Successivo appena avrai riempito tutto lo spazio del container.",
        "message": "Per riempire al massimo della sua capacità il container, bisogna rimuovere dei pallet."
      },
      "overfilled-no-product": {
        "description": "La tua attuale selezione di prodotti non entra nello spazio disponibile nel container. Riduci la tua selezione di prodotti di {count} pallet.",
        "message": "Hai aggiunto troppi pallet."
      },
      "totals": {
        "boxes": "Scatoloni:",
        "kg": "kg",
        "pallets": "Pallet:",
        "title": "Totale",
        "weight": "Stima del peso lordo:"
      },
      "underfilled": {
        "description": "Ti abbiamo dato un suggerimento basandoci sull’articolo con la quantità più alta. Puoi accettare la configurazione cliccando sul pulsante arancione. Puoi sempre fare modifiche diverse cambiando la quantità di qualsiasi articolo nell’elenco. Clicca su Successivo appena avrai riempito tutto lo spazio del container.",
        "message": "Per riempire al massimo della sua capacità il container, bisogna aggiungere dei pallet."
      }
    },
    "steps": {
      "select-products": "Seleziona i prodotti per il container",
      "summary": "Download del calcolo dell'ordine in CSV"
    },
    "suggestion": {
      "add": "Aggiungi {amount}",
      "reduce": "Riduci {amount}"
    }
  },
  "contracts": {
    "contract": {
      "general": {
        "contract-no": "Numero contratto:",
        "to": "per",
        "total-volume": "Volume totale del contratto:",
        "valid-from-to": "Valido da/a"
      }
    },
    "disclaimer": {
      "block-1": {
        "content": "A causa dei cambiamenti di mercato, le informazioni nei contratti a volume possono variare. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam vestibulum, sapien eu congue venenatis, orci sem euismod felis, at consectetur dui massa id felis. Nulla et odio felis. Ut congue in neque ut pretium. Etiam elementum, ligula eu consequat varius, nisi risus ultricies libero, sed tristique enim nibh at velit. Fusce facilisis sed augue sed maximus. Quisque non leo tempor, elementum tellus accumsan, hendrerit risus. Nam nec efficitur lorem. Quisque vitae eros diam.",
        "title": "Cambiamenti di mercato"
      },
      "block-2": {
        "content": "Etiam vestibulum, sapien eu congue venenatis, orci sem euismod felis, at consectetur dui massa id felis. Nulla et odio felis. Ut congue in neque ut pretium. Etiam elementum, ligula eu consequat varius, nisi risus ultricies libero, sed tristique enim nibh at velit.",
        "title": "Scambio di prodotti nei contratti\n"
      },
      "button": "Vai ai miei contratti a volume",
      "card": {
        "link": "disclaimer",
        "text": "Leggi il nostro disclaimer per ulteriori informazioni sulle possibili variazioni in questa panoramica"
      },
      "need-help": {
        "content": "Se hai domande o se necessiti di informazioni più dettagliate sui tuoi contratti a volume, contatta il tuo {link}.",
        "link": "referente o il team dedicato all'esperienza del cliente",
        "title": "Ho bisogno di aiuto?"
      },
      "title": "Disclaimer"
    },
    "download": {
      "button": "Scarica",
      "label": "Seleziona le informazioni del contratto che desideri scaricare"
    },
    "header": {
      "intro": "Ottieni informazioni dettagliate sui tuoi contratti. In caso di domande, non esitare a contattarci.",
      "title": "I miei contratti a volume"
    },
    "products": {
      "header": {
        "billed-qty": "Qtà fatturata KG",
        "code": "Codice LW",
        "contract-qty": "Qtà Contr. KG",
        "kg-left": "KG rimasti",
        "material": "Materiale",
        "open-orders": "Ordini aperti KG",
        "percent-left": "% rimasta",
        "product": "Nome del prodotto"
      }
    }
  },
  "dashboard": {
    "invoices": {
      "go-to-my-invoices": "Vai alle fatture",
      "my-invoices": "Fatture",
      "open-invoices": "Apri fatture",
      "upcoming": "In arrivo",
      "your-open-invoices": "Fatture aperte"
    },
    "orders": {
      "go-to-orders-overview": "Vai alla panoramica ordini e consegne",
      "last-order": "Ultimo ordine",
      "my-orders-deliveries": "Ordini e consegne",
      "no-last-order": "Nessun ultimo ordine disponibile",
      "order-date": "Data ordine",
      "order-status": "Stato ordine",
      "your-orders-deliveries": "ordini e consegne"
    }
  },
  "e-learning": {
    "action": {
      "continue": "Continua",
      "enroll": "Iscriviti",
      "view": "Visualizza"
    },
    "course": {
      "finish": {
        "button": "Ho terminato questo corso",
        "description": "Clicca sul pulsante per registrare che il corso è stato terminato.",
        "title": "Hai terminato questo corso?"
      },
      "header": {
        "back": "Torna alla panoramica",
        "status": "Stato:"
      },
      "related": {
        "default-title": "Altri corsi"
      }
    },
    "minutes": "minuti",
    "overview": {
      "empty": "Nessun corso trovato",
      "search-bar": {
        "category": {
          "all": "Tutti",
          "placeholder": "Categoria: Tutti"
        },
        "duration": {
          "all": "Tutti",
          "more-than": "Più di",
          "placeholder": "Durata: Tutti"
        },
        "result-title": "({count}) Risultati di ricerca per: | ({count}) Risultati di ricerca per: | ({count}) Risultati di ricerca per: ",
        "search": {
          "placeholder": "Cerca..."
        },
        "status": {
          "all": "Tutti",
          "placeholder": "Stato: Tutti"
        }
      },
      "title": "E-learning"
    },
    "status": {
      "completed": "Completato",
      "in-progress": "In corso",
      "not-started": "Non iniziato"
    }
  },
  "eatThis": {
    "download": "scarica",
    "open": "apri"
  },
  "error": {
    "error_404": {
      "title": "oops, pagina non trovata"
    },
    "error_500": {
      "title": "oops, errore 500"
    },
    "general": {
      "subtitle": "sembra che questa pagina non funzioni",
      "title": "oops, errore sconosciuto"
    }
  },
  "footer": {
    "copyright": "© {year} Tutti i diritti riservati Lamb Weston",
    "navigation": {
      "privacy": "Privacy",
      "profile": "Profilo",
      "terms-and-conditions": "Condizioni"
    }
  },
  "general": {
    "for": "per",
    "interface": {
      "back": "Indietro",
      "cancel": "Cancella",
      "close": "Chiudi",
      "remove": "Rimuovere",
      "save": "Salva",
      "update": "Aggiornamento",
      "none": "Nessuno",
      "noResultsFound": "Nessun risultato trovato",
      "all": "Tutto",
      "create": "Creare",
      "next": "Prossimo"
    },
    "locale": {
      "de": "Tedesci",
      "en-GB": "Inglese",
      "es": "Spagnolo",
      "fr": "Francese",
      "it": "Italiano",
      "nl": "Olandese"
    },
    "messages": {
      "error": "Si è verificato un errore imprevisto."
    },
    "table": {
      "not-available": "non disponibile"
    },
    "dialog": {
      "confirm_delete_message": "Sei sicuro di voler eliminare questo elemento?"
    }
  },
  "home": {
    "intro": "Nel portale clienti Lamb Weston.",
    "title": "Benvenuto{fullname},",
    "subtitle": "Forniamo con orgoglio a {customerName}"
  },
  "invoices": {
    "column": {
      "amount": "Importo",
      "details": "Info",
      "expire-date": "Data di scadenza",
      "invoice-nr": "N. fattura",
      "posting-date": "Data di invio",
      "sales-order": "Ordine di vendita",
      "sales-order-show": "mostra",
      "status": "Stato"
    },
    "detail": {
      "label": {
        "amount": "Importo",
        "currency": "Valuta",
        "expire-date": "Data di scadenza",
        "invoice-number": "Numero fattura",
        "order-reference": "Referenza ordine",
        "payment-terms-code": "Codice termini di pagamento",
        "payment-terms-description": "Descrizione termini di pagamento",
        "posting-date": "Data di invio",
        "relevant-bill-to": "Intestatario pertinente",
        "relevant-payer": "Pagatore pertinente",
        "sales-order-ship-to": "Destinatario Ordine di vendita",
        "type-commercial": "Tipo commerciale"
      },
      "pdf-download": "Fattura scaricabile PDF",
      "sales-order": {
        "close": "Chiudi messaggio",
        "order-overview": "Vai agli ordini",
        "title": "Fattura {invoice} - Ordine di vendita"
      },
      "show-sales-order": "mostra ordine di vendita"
    },
    "empty": "Nessuna fattura disponibile",
    "header": {
      "intro": "In questa pagina puoi trovare e scaricare le tue fatture. Fai clic su una riga per maggiori informazioni.",
      "title": "Fatture"
    },
    "search-bar": {
      "placeholder": {
        "all-invoices": "Tutte le fatture",
        "filter": "Filtra fatture",
        "search": "Cerca…"
      },
      "total": "Totale",
      "total-filtered": "Totale filtrato"
    },
    "status": {
      "before due": "pagamenti dovuti",
      "cleared": "pagato",
      "days-till-due-date": "{count} giorni|{count} giorno|{count} giorni",
      "due date": "data di scadenza",
      "overdue": "scaduta",
      "reversed": "annullata"
    }
  },
  "menuEngineering": {
    "categories": {
      "laggard": "ritardatario",
      "runner": "corridore",
      "sleeper": "dormiglione",
      "winner": "vincitore"
    },
    "imageAlt": {
      "icon": "Icona categoria chef",
      "laggard": "Chef categoria ritardatario",
      "runner": "Categoria Chef corridore",
      "sleeper": "Categoria Chef dormiglione",
      "winner": "Categoria Chef vincitore"
    },
    "label": {
      "addDishEquation": "Il tuo piatto è stato aggiunto all’equazione",
      "categoryResult": {
        "intro": "Di seguito troverai i risultati dei tuoi piatti nelle quattro categorie di",
        "link": "ingegnerizzazione dei menu",
        "outro": "Clicca sulla categoria per vedere quale dei tuoi piatti rientra nella stessa e scopri come ottimizzarlo"
      },
      "companySeatCount": "Quanti coperti hai",
      "companyStaffSize": "Dimensioni del tuo staff",
      "cost": "Costa della materia prima",
      "course": {
        "breakfast": "Colazione",
        "dinner": "Cena",
        "inbetween": "Spuntino",
        "lunch": "Pranzo",
        "snack_time": "Spuntino serale"
      },
      "courseDish": "Momento di consumo",
      "dishNotDeleted": "Impossibile eliminare il piatto",
      "editDish": "Il tuo piatto è stato modificato",
      "goodCalculation": "Servono almeno 5 piatti per effettuare un calcolo adeguato.",
      "helpTime": "Tempo di preparazione (min)",
      "info": {
        "cost": "Prezzo totale degli ingredienti del piatto",
        "helpTime": "Tempo impiegato dalla brigata di cucina per preparare il piatto",
        "popularity": "Quante volte alla settimana è venduto questo piatto",
        "price": "Prezzo di vendita del piatto al lordo delle imposte",
        "time": "Tempo impiegato dal cuoco per preparare il piatto"
      },
      "insufficientDishes": "Ci servono almeno altri {count} piatti per fare un buon calcolo.",
      "laggard": {
        "demand": "Bassa richiesta",
        "profit": "Basso profitto"
      },
      "laggards": "Ritardatario",
      "nameOfDish": "Nome del piatto",
      "optionRestaurant": "Ristorante",
      "popularity": "Popolarità (volte a settimana)",
      "price": "Prezzo di vendita IVA escl.",
      "runner": {
        "demand": "Elevata richiesta",
        "profit": "Basso profitto"
      },
      "runners": "Corridore",
      "selectCourse": "Momento di consumo.",
      "selectCourseLabel": "scegli un consumo",
      "sleeper": {
        "demand": "Bassa richiesta",
        "profit": "Alto profitto"
      },
      "sleepers": "Dormiglione",
      "thinkOfYourDish": "Pensa ad uno dei tuoi piatti e compila il modulo.",
      "time": "Tempo di cottura (min)",
      "typeOfRestaurant": "Quale tipo di ristorante hai?",
      "winner": {
        "demand": "Elevata richiesta",
        "profit": "Alto profitto"
      },
      "winners": "Vincitore"
    },
    "overview": {
      "addAnotherDish": "Salva e aggiungine un altro",
      "addDish": "Aggiungi un piatto",
      "addDishEquation": "Aggiungi un piatto all’equazione",
      "calculateNow": "E ora calcola",
      "cancel": "Annulla",
      "categoryCompare": "Confrontandolo con altri piatti presenti sul mercato, il tuo piatto risulta",
      "categoryResult": {
        "intro": "Questi sono i piatti",
        "outro": "all' interno della categoria nel tuo menu"
      },
      "deleteProfile": "Stai per eliminare il tuo profilo",
      "dishes": "Piatti",
      "menuEngineering": "ïngegnerizzazione del menu",
      "results": "Risultati",
      "save": "Salva",
      "showResults": "Mostra i risultati",
      "startMenuEngineering": "Inizia ad ingegnerizzare il tuo menu",
      "testValueDishes": "Testa il valore dei tuoi piatti",
      "typeOfRestaurant": "Tipo di ristorante",
      "yourDish": "Il tuo piatto"
    },
    "placeholder": {
      "typeOfRestaurant": "Ad es. Steakhouse, pizzeria, ecc."
    },
    "results": {
      "back-to-results": "Torna ai miei risultati",
      "title": "I risultati del mio menu engineering"
    },
    "try-out": {
      "dish-form": {
        "subtitle": "Pensa ad uno dei tuoi piatti e compila il modulo.",
        "title": "2. Il tuo piatto"
      },
      "hero": {
        "subtitle": "Menu engineering helps evaluate your dishes on the menu and get an overview of your best and worst performers.",
        "title": "Testa il reale valore dei tuoi piatti"
      },
      "intro": {
        "text": "Menu engineering compares the dishes relative to each other, you will therefor always have winners, sleepers, runners and laggards. In order to get a good result only compare similar dishes of the menu such as the segment “main courses”.",
        "title": "Menu engineering",
        "try": "Try it for one dish below!"
      },
      "restaurant-type": {
        "label": "Can you tell us what restaurant?",
        "subtitle": "Quale tipo di ristorante hai?",
        "title": "1. Tipo di ristorante"
      },
      "result": {
        "sign-up": "Unisciti a noi per confrontare i tuoi piatti"
      }
    }
  },
  "navigation": {
    "approved-products": "{company} Portafoglio",
    "back-to-overview": "Torna alla panoramica",
    "best-practices": "Procedure consigliate/Guida Playbook",
    "container-calculation": "Calcolo container",
    "dashboard": "Dashboard",
    "e-learning": "E-learning",
    "eat-this": "Eat This!",
    "lwm-company-information": "Azienda Lamb Weston",
    "lwm-contact": "Contatti Lamb Weston",
    "market-activations": "Attivazioni del mercato",
    "menu-engineering": {
      "add-dish": "Aggiungi un piatto",
      "main": "Menu Engineering",
      "my-results": "I miei risultati",
      "try-out": "Testa il reale valore dei tuoi piatti"
    },
    "my-agreements": "I miei accordi",
    "my-claims": "Le mie richieste",
    "my-invoices": "Fatture",
    "my-orders": "Ordini e consegne",
    "my-volume-contracts": "I miei contratti a volume",
    "new-products": "Innovazioni e tendenze",
    "partnership": "Partnership {company}",
    "permission-mgt": "Gestione autorizzazioni",
    "product-information": "Informazioni sul prodotto",
    "products-for": "Portfolio {company}",
    "settings": {
      "main": "Impostazioni",
      "my-profile": "Il mio profilo"
    },
    "sign-out": "Disconnessione",
    "sustainability": "Agenda per la sostenibilità",
    "training": "Operazioni e formazione",
    "trend-information": "Informazioni sulle tendenze",
    "user-management": "Gestione utente",
    "dock-scheduler": "Pianificatore di attracco",
    "dock-scheduler-booking": "Panoramica della prenotazione",
    "dock-scheduling-rules": "Regole per la programmazione delle banchine"
  },
  "onboarding": {
    "authenticator": {
      "error": {
        "InvalidParameterException": "Il codice di convalida deve essere di 6 caratteri.",
        "unknown": "Si è verificato un problema, riprova."
      },
      "finish": "Fine",
      "qr-description": "Scannerizza il codice QR con la tua app di autenticazione per ottenere il codice MFA.",
      "qr-title": "Codice MFA",
      "step-title": "Imposta il token di autenticazione",
      "steps": "Scarica l'app Google authenticator dal negozio Apple o Android|Premi l'icona \"+\"|Seleziona \"Scannerizza codice QR\"|Inserisci il codice dell'app nel campo \"Codice di verifica",
      "title": "App Authenticator"
    },
    "change-mfa": "Modifica",
    "finished": {
      "features-enabled": "Tutte le funzionalità del portale sono ora disponibili.",
      "finish": "Vai alla dashboard",
      "intro": {
        "authenticator": "Grazie per aver impostato l'autenticazione a più fattori.\nD'ora in poi potrai accedere utilizzando l'autenticazione a più fattori con la tua app authenticator.",
        "sms": "Grazie per aver impostato l'autenticazione a più fattori.\nD'ora in poi potrai accedere utilizzando l'autenticazione a più fattori con un messaggio di testo sul tuo telefono."
      },
      "title": "Autenticazione verificata!"
    },
    "mfa-preference": "Preferenze autenticazione a più fattori",
    "none": {
      "description": "Quando non imposti un metodo di autenticazione a più fattori puoi utilizzare solo le funzionalità del portale che non lo richiedono. Se procedi senza impostare l'MFA visualizzerai di nuovo questo popup alla tua prossima visita.",
      "finish": "Utilizza senza MFA",
      "title": "Non abilitare MFA"
    },
    "sms": {
      "change-phone": "Modifica numero di telefono",
      "code-sent": "Abbiamo inviato un codice al tuo telefono.",
      "finish": "Fine",
      "request-code": "Richiedi codice",
      "steps": "Inserisci il tuo numero di telefono e premi Richiedi codice |entro pochi secondi dovresti ricevere un messaggio di testo con un codice di verifica|Inserisci il codice di verifica e premi Fine per completare l'attivazione.",
      "title": "Messaggi di testo SMS"
    },
    "welcome": {
      "buttons": {
        "authenticator": {
          "label": "(usa un codice QR e un'app MFA per salvare un token sul tuo dispositivo mobile)",
          "type": "App Authenticator"
        },
        "none": {
          "label": "",
          "type": "Non abilitare MFA"
        },
        "sms": {
          "label": "(ricevi un codice sul tuo dispositivo mobile).",
          "type": "Messaggi di testo SMS"
        }
      },
      "explanation-description": "L'autenticazione a più fattori (MFA) aggiunge un ulteriore livello di protezione oltre al nome utente e alla password. Per abilitare l'autenticazione via SMS, inserisci qui sopra un numero di cellulare valido.",
      "explanation-title": "Preferenze autenticazione a più fattori",
      "recommend-description": "Per motivi di sicurezza consigliamo di usare anche l'autenticazione a più fattori.",
      "required-description": "Ti diamo il benvenuto nel portale clienti! Per avere accesso a tutte le funzionalità del portale clienti è necessaria l'autenticazione a più fattori. ",
      "title": "Ti diamo il benvenuto!"
    }
  },
  "orders": {
    "card": {
      "footer": {
        "order-again": "Ordina di nuovo questi prodotti",
        "reorder": "Vuoi ripete questo ordine? Fai clic sul pulsante ordina di nuovo questi prodotti.",
        "summary-info": "* La composizione dell'ordine può variare in base alla disponibilità di magazzino; seguirà conferma degli articoli e delle quantità. Lamb Weston e i suoi partner per la logistica faranno del loro meglio per rispettare la data di consegna richiesta, ma la data di consegna effettiva sarà comunicata in seguito."
      },
      "header": {
        "bill-of-lading": "Polizza di carico (BOL):",
        "close": "chiudi",
        "container-numbers-long": "Numero di Container ({count})",
        "container-numbers-short": "N.",
        "more": "altro",
        "order-city": "Destinazione:",
        "order-date": "Data ordine:",
        "order-no": "LW #: ",
        "order-ref": "Rif. ordine:",
        "order-reference": "Riferimento ordine:",
        "products-to-order": "Prodotti da ordinare"
      },
      "status": {
        "delivery-date": "Consegna:",
        "label": "Stato:",
        "more-info": "altre informazioni sullo stato dell'ordine"
      }
    },
    "group": {
      "last-order": "Il tuo ultimo ordine",
      "see-products": "fai clic per vedere i prodotti"
    },
    "header": {
      "intro": "Qui sotto puoi inserire nuovi ordini, visualizzare la cronologia degli ordini o riordinare rapidamente un ordine precedente. ",
      "new-order-button": "Effettua un nuovo ordine",
      "title": "I miei ordini"
    },
    "new": {
      "confirm-dialog": {
        "button": "Chiudi messaggio",
        "message": "La composizione dell'ordine sarà confermata dal nostro Servizio Clienti. Potrebbe volerci un minuto prima che il tuo ordine appaia nella panoramica degli ordini.",
        "title": "Grazie per aver ordinato da Lamb Weston"
      },
      "footer": {
        "back": "Vai indietro",
        "cancel": "Cancella",
        "confirm": "Conferma ordine",
        "next": "Successivo",
        "recalculate": "Ricalcola"
      },
      "preferred-warehouse": "**Hai selezionato il magazzino: {code},** a causa di questa selezione per questo ordine puoi **ordinare solo prodotti da questo magazzino.** Se desideri ordinare prodotti da **un altro magazzino,** ti preghiamo di **creare un ordine separato.**",
      "help-text": "La denominazione del prodotto consiste di dimensioni del taglio e del peso delle confezioni.",
      "intro": "Puoi effettuare i tuoi ordini in modo veloce e facile. Una volta che l'ordine è stato inserito nel sistema e processato, sarai contattato del nostro dipartimento Customer Experience per i dettagli di pagamento e consegna.",
      "products-title": "Gamma di prodotti Lamb Weston",
      "products-unavailable": {
        "button": "Vai alla selezione prodotto",
        "item-label": "Non disponibile",
        "message": "Il tuo riordine attuale contiene un prodotto che non è più disponibile. Ti preghiamo di selezionare un prodotto altenativo sulla schermata di selezione prodotto. Abbiamo aggiuno gli altri prodotti dall'rdine precedente al tuo elenco degli ordini.",
        "title": "Ordina di nuovo questi prodotti - {count} prodotto/i non disponibile/i"
      },
      "repeat-button": {
        "large1": "Vuoi ripetere un ordine precedente?",
        "large2": "Torna all'anteprima ordine",
        "small": "ripeti ordine?"
      },
      "steps": {
        "order-reference-and-shipping": "Riferimento ordine e Spedizione",
        "order-summary-and-confirmation": "Sommerio ordine e Conferma",
        "select-products": "Seleziona prodotti"
      },
      "suggest-fill-scale": {
        "footer": {
          "message": "Per accettare, fai clic sul pulsante arancione. Puoi apportare modifiche alternative cambiando la quantità di qualsiasi articolo dell'elenco oppure puoi ignorare il nostro suggerimento e passare alla fase successiva del processo d'ordine.",
          "title": "Possiamo ottimizzare il tuo ordine! Ti abbiamo offerto un suggerimento per far sì che il tuo ordine rientri nella scala di volumi del prossimo ordine."
        },
        "tooltip": {
          "message": "Aggiungi **+{quantity}** pallet per usufruire di una tariffa di trasporto più bassa.",
          "title": "Possiamo ottimizzare il tuo ordine!"
        }
      },
      "suggest-fill-truck": {
        "footer": {
          "message": "Per accettare, fai clic sul pulsante arancione. Puoi apportare modifiche alternative cambiando la quantità di qualsiasi articolo dell'elenco oppure puoi ignorare il nostro suggerimento e passare alla fase successiva del processo d'ordine.",
          "title": "Possiamo ottimizzare il tuo ordine! Ti abbiamo offerto un suggerimento per far sì che il tuo ordine riempia il camion."
        },
        "tooltip": {
          "message": "Aggiungi **+{quantity}** pallet per riempire il camion.",
          "title": "Possiamo ottimizzare il tuo ordine!"
        }
      },
      "suggest-remove": {
        "footer": {
          "message": "Ti abbiamo offerto un suggerimento basato sulla tua riga d'ordine dal valore più elevato. Per accettare, fai clic sul pulsante arancione. Puoi apportare modifiche alternative cambiando la quantità di qualsiasi articolo dell'elenco. Fai clic su ricalcola per continuare quando hai modificato l'ordine.",
          "title": "Hai superato il peso massimo del camion di {quantity} pallet ({exceededWeight} kg, pallet compresi)."
        },
        "tooltip": {
          "message": "Riduci la quantità di questo articolo di **-{quantity}**. Cancella per ridurre la quantità di altri articoli.",
          "title": "Hai superato il peso massimo del camion."
        }
      },
      "suggestion": {
        "accept": "Accetta",
        "cancel": "Cancella"
      },
      "title": "Nuovo ordine"
    },
    "custom-label-switch": {
      "title": "Mostra etichette originali",
      "description": "Questo mostrerà le informazioni originali sul prodotto fornite da LambWeston quando attivato.",
      "checkbox": "Mostra il nome e il numero originali del prodotto"
    },
    "order-item-list": {
      "header": {
        "art": "Materiale",
        "boxes": "Scatole",
        "code": "Codice LW",
        "warehouse": "Magazzino",
        "layers": "Strati",
        "pallets": "Pallet",
        "product": "Prodotto",
        "products": "Prodotti",
        "quantity": "Quantità",
        "unit-type": "Tipo di unità"
      },
      "totals": {
        "grand-total": "Totale complessivo",
        "kg": "kg",
        "total-cartons": "Scatoloni | Scatolone | Scatoloni",
        "total-gross-weight": "Peso lordo",
        "total-layers": "Strati | Strato | Strati",
        "total-net-weight": "Peso netto",
        "total-pallets": "Pallet | Pallet | Pallet"
      },
      "unit": {
        "bag": "Borsa",
        "car": "Scatoloni",
        "kg": "kg",
        "lay": "Strati",
        "pal": "Pallet"
      }
    },
    "overview": {
      "closed-orders-title": "Ordini chiusi",
      "empty": "Nessun ordine disponibile",
      "header": {
        "eta-actual": "ETA effettivo",
        "eta-booked": "ETA prenotato",
        "eta-requested": "Req. ETA",
        "more": "altro",
        "order-city": "Destinazione",
        "order-date": "Data ordine",
        "order-no": "LW #",
        "order-ref": "Rif. ordine",
        "order-reference": "Riferimento ordine",
        "order-status": "Stato ordine"
      },
      "open-orders-title": "Ordini aperti",
      "search-bar": {
        "query": {
          "placeholder": "Ricerca di un ordine specifico..."
        },
        "status": {
          "all": "Tutti gli ordini",
          "placeholder": "Stato dell'ordine"
        }
      }
    },
    "reference": {
      "intro": "Se vuoi aggiungere un numero di riferimento dell'ordine/numero di acquisto dell'ordine per il tuo ordine, completa il campo di riferimento dell'ordine.",
      "number": {
        "max-characters": "(massimo 20 caratteri)",
        "placeholder": "Aggiungi il numero di riferimento del tuo ordine",
        "title": "Riferimento dell'ordine"
      },
      "title": "Il tuo riferimento dell'ordine"
    },
    "search-bar": {
      "placeholder": {
        "set-preferred-warehouse": "Imposta magazzino preferito",
        "filter-products": "Filtra prodotti",
        "search": "Cerca un prodotto specifico...",
        "search-alt": "cerca"
      }
    },
    "shipping": {
      "delivery-date": {
        "label": "questa data è una stima",
        "title": "Data di consegna preferita"
      },
      "eta": {
        "delayed": "ritardo",
        "early": "anticipo",
        "eta": "ETA:"
      },
      "ship-to": {
        "title": "Spedisci a"
      },
      "title": "Spedizione"
    },
    "status": {
      "AWS_CREATED": "Ricevuto da Lamb Weston",
      "DELIVERED": "Consegnato",
      "SAP_CANCELLED": "Annullato",
      "SAP_CREATED": "Accettato",
      "SAP_PROCESSING": "In elaborazione",
      "SAP_PROCESSING_PART": "In elaborazione",
      "SAP_SHIPPED": "Spedito",
      "SAP_SHIPPED_PART": "Spedito",
      "SAP_UNKNOWN": "Sconosciuto",
      "more-info": {
        "AWS_CREATED": "L'ordine è stato completato e confermato attraverso il Portale clienti. Email di conferma inviata.",
        "DELIVERED": "Conferma che la merce è stata consegnata al luogo di spedizione.",
        "SAP_CANCELLED": "L'ordine è stato annullato.",
        "SAP_CREATED": "L'ordine è stato completato, creato in uscita, nessun blocco, nessun rifiuto.",
        "SAP_PROCESSING": "L'ordine è in fase di elaborazione e controllo da parte della Customer Experience di LW.",
        "SAP_PROCESSING_PART": "Elaborazione in sap, ordine parzialmente accettato.",
        "SAP_SHIPPED": "L'ordine è stato completamente caricato PGI ricevuto.",
        "SAP_SHIPPED_PART": "Consegna sap creata, ordine parzialmente accettato.",
        "SAP_UNKNOWN": "Per ulteriori informazioni, contatta il rappresentante della Customer Experience."
      },
      "part": "partly",
      "partly": "non completo"
    },
    "summary": {
      "delivery-date": "Spedisci a e data di consegna preferita",
      "title": "Sommario del tuo ordine"
    },
    "warning": {
      "requires-mfa": "La gestione degli ordini è disponibile solo per gli utenti che hanno attivato l'autenticazione multifattore. Puoi impostare la tua autenticazione multifattore in:"
    }
  },
  "permission-mgt": {
    "column": {
      "actions": {
        "delete": "Cancella",
        "get": "Leggi",
        "label": "Azioni",
        "post": "Crea",
        "put": "Aggiorna",
        "tooltip": "Maggiori informazioni su queste azioni"
      },
      "configure": {
        "label": "Configura",
        "tooltip": "Maggiori informazioni su Configura"
      },
      "delete": {
        "label": "Cancella",
        "tooltip": "Maggiori informazioni su Cancella"
      },
      "effect": {
        "label": "Effetto",
        "tooltip": "Maggiori informazioni su Effetto"
      },
      "endpoint": {
        "label": "Endpoint",
        "tooltip": "Maggiori informazioni su Endpoint"
      },
      "field": {
        "label": "Campo"
      },
      "model": {
        "label": "Modello"
      },
      "operator": {
        "label": "Operatore"
      },
      "value": {
        "label": "Valore"
      },
      "wildcard": {
        "label": "Per l'endpoint jolly",
        "tooltip": "Maggiori informazioni su carattere jolly"
      }
    },
    "effect": {
      "allow": "Permetti",
      "deny": "Nega"
    },
    "intro": "Gestisci i ruoli degli utenti e le loro autorizzazioni. Seleziona prima un ruolo o aggiungi un nuovo ruolo.",
    "policies": {
      "add": "Aggiungi una nuova policy",
      "configure": {
        "actions": "Azioni",
        "effect": "Effetto",
        "endpoint": "Endpoint",
        "for-wildcard-endpoint": "Per l'endpoint jolly",
        "id": "ID",
        "locale": "Locale",
        "title": "Configura policy",
        "wildcard": "Carattere wildcard"
      },
      "delete": {
        "cancel": "Annulla",
        "confirm": "Cancella policy",
        "message": "Sei sicuro di voler cancellare questa policy? Questa azione non può essere annullata.",
        "success": "Policy cancellata",
        "title": "Cancellazione policy in corso"
      },
      "intro": "Policy per questo ruolo. Puoi configurare le policy per questo ruolo facendo clic sul pulsante configura e "
    },
    "policy-form": {
      "cancel": "Annulla",
      "endpoint": {
        "label": "Endpoint",
        "placeholder": "Seleziona un endpoint"
      },
      "filters": {
        "add": "Aggiungi un nuovo filtro",
        "title": "Filtri policy"
      },
      "placeholder": {
        "select": {
          "field": "Seleziona un campo",
          "model": "Seleziona un modello",
          "operator": "Seleziona un operatore"
        }
      },
      "submit": "Salva ed esci",
      "title": "Configura policy"
    },
    "role": {
      "add": "Aggiungi un nuovo ruolo",
      "edit": "Modifica il nome del ruolo",
      "form": {
        "cancel": "Annulla",
        "error": "Si è verificato un errore durante il salvataggio del ruolo",
        "name": {
          "label": "Nome",
          "placeholder": "Inserisci il nome del ruolo"
        },
        "submit": "Salva",
        "success": "Ruolo salvato",
        "title": "Ruolo"
      },
      "placeholder": "Seleziona un ruolo"
    },
    "select-role": "Seleziona prima un ruolo o fai clic su aggiungi nuovo ruolo.",
    "title": "Gestione autorizzazioni"
  },
  "product-information": {
    "contact": {
      "description": "Vuoi chiedere informazioni su un nuovo prodotto? Oppure su un prodotto che non è nel tuo elenco?",
      "link": "Contatta l'assistenza cliente",
      "subject": "Portale clienti informazioni sul prodotto"
    },
    "detail": {
      "intro": "Qui puoi trovare tutte le informazioni disponibili su questo prodotto.",
      "packaging": {
        "cartons": "cartoni",
        "cm": "cm",
        "commodity-code": "Codice armonizzato",
        "dimensions": "Dimensioni",
        "ean-upc": "Numero EAN",
        "gross-weight": "Peso lordo",
        "height": "altezza",
        "kg": "kg",
        "layers": "strati",
        "length": "lunghezza",
        "material": "Materiale",
        "net-weight": "Peso netto",
        "pallet-type": "Tipo di pallet",
        "shelf-life-code": "Codice durata di conservazione",
        "title": "Confezione e dimensioni",
        "unit": {
          "bag": "Confezione/sacchetto",
          "car": "cartone",
          "lay": "Strato",
          "pal": "Pallet"
        },
        "width": "larghezza"
      },
      "product-sheet": {
        "download-button": "Scarica la scheda prodotto in pdf",
        "information-list": "Informazioni nutrizionali|Informazioni sugli allergeni|Informazioni sulla preparazione|Informazioni di esempio",
        "intro": "All'interno di questa scheda tecnica del prodotto commerciale è possibile trovare le seguenti informazioni.",
        "subtitle": "Scheda delle specifiche del prodotto commerciale in PDF",
        "title": "Scheda prodotto"
      }
    },
    "header": {
      "intro": "Qui puoi trovare le informazioni disponibili sul prodotto. Clicca su maggiori informazioni per vedere i dettagli del prodotto.",
      "title": "Informazioni sul prodotto"
    },
    "list": {
      "empty": "Nessun prodotto disponibile",
      "header": {
        "details": "maggiori informazioni",
        "download": "scarica pdf"
      }
    }
  },
  "profile": {
    "account-settings": {
      "edit": "Modifica impostazioni account",
      "title": "Impostazioni account"
    },
    "edit": "modifica",
    "email": {
      "confirmation-code": "Inserisci il tuo codice di conferma"
    },
    "error": {
      "failed": "Si è verificato un errore durante il salvataggio del tuo profilo",
      "success": "Il tuo profilo è stato salvato",
      "wrongPassword": "Hai inserito una password errata"
    },
    "label": {
      "cancel": "Cancella",
      "change-password": "****************",
      "city": "Città",
      "country": "Paese",
      "edit": "Modifica profilo",
      "email": "Indirizzo e-mail",
      "firstName": "Nome",
      "functionTitle": "Mansione",
      "lastName": "Cognome",
      "locale": "Lingua",
      "newPassword": "Nuova password",
      "newPasswordRepeat": "Inserisci di nuovo la password",
      "oldPassword": "Vecchia password",
      "phone": "Recapito telefonico",
      "restaurantCity": "Città",
      "restaurantCountry": "Paese",
      "restaurantName": "Nome di ristorante",
      "restaurantNumber": "Numero",
      "restaurantPostalcode": "Codice postale",
      "restaurantSeats": "Coperti",
      "restaurantStreet": "Via",
      "restaurantTelephone": "Numero di telefono",
      "restaurantType": "Tipo di ristorante",
      "restaurantWebsite": "Sito Internet",
      "save": "Salva"
    },
    "locale": {
      "change-success": "La tua lingua è stata cambiata"
    },
    "mfa": {
      "current-mfa": "Installed:",
      "method": {
        "NOMFA": "non c'è autenticazione multifattore",
        "SMS": "SMS (ricevi un codice su dispositivo mobile)",
        "TOTP": "password monouso (con app di autenticazione)"
      },
      "mfa-description": "L'autenticazione a più fattori (MFA) aggiunge un ulteriore livello di protezione oltre a quello fornito da nome utente e password. Per abilitare l'autenticazione via SMS, inserisci qui sopra un numero di cellulare valido",
      "no-mfa-description": "Non abilitare MFA",
      "setup-mfa": "Preferenza di autenticazione multifattore",
      "sms-description": "SMS (ricevi un codice su dispositivo mobile). Il telefono deve essere correttamente impostato.",
      "token-instructions": "Per ottenere il codice MFA, scansiona il codice QR con la fotocamera del tuo telefono o con l'app di autenticazione.",
      "totp-description": "Password monouso (usa un codice QR e un'app MFA per salvare un token sul tuo dispositivo mobile)",
      "totp-info": {
        "1-select-option": "Seleziona \"Password monouso\" come opzione qui sopra e fai clic su \"Imposta MFA\".",
        "2-get-app": "Ottieni il {0} per il tuo dispositivo mobile",
        "2-get-app-link": "App Google Authenticator",
        "3-press-plus": "Premi l'icona \"+\"",
        "4-select-scan": "Seleziona \"Scansiona codice QR\"",
        "5-enter-code": "Inserisci il codice dell'app come \"Codice di verifica\"",
        "title": "Come impostare l'autenticazione con una password monouso"
      }
    },
    "no-profile-placeholder": "Inserisci le informazioni del tuo profilo per ottenere un'esperienza ottimale sul portale clienti. Fai clic sull'icona nell'angolo destro per modificare.",
    "password": {
      "change-success": "La tua password è stata modificata",
      "do-not-match": "Le password non corrispondono",
      "invalid": "La password deve avere i seguenti requisiti: lunghezza minima della password di almeno 6 caratteri; deve contenere lettere maiuscole dell'alfabeto inglese (A-Z); deve contenere lettere minuscole dell'alfabeto inglese (a-z); deve contenere numeri del sistema decimale (0-9)."
    },
    "phone": {
      "invalid-phone-number": "Il numero di telefono fornito non è valido",
      "unknown-error": "Si è verificato un errore, il numero di telefono non è stato salvato"
    },
    "placeholder": {
      "city": "ad es. Londra, Roma",
      "close": "Chiusura",
      "confirmation-code": "123456",
      "country": "Seleziona il tuo paese",
      "email": "mail@chefs.network",
      "functionTitle": "ad es. chef, Sous-chef, ecc",
      "number": "ad es. 9, Appartamento 12F, ecc.",
      "open": "Apertura",
      "password": "Password",
      "phone": "555-3891203812",
      "restaurant": {
        "seats": "ad es. 100",
        "type": "ad es. steakhouse, pizzeria, ecc."
      },
      "staff": "ad es. 2",
      "street": "ad es. via principale",
      "zip": "ad es. W1U 3BW, 00118, ecc."
    },
    "restaurant": {
      "add": "Aggiungi un altro ristorante",
      "address": "Indirizzo",
      "basic": "Base",
      "delete": {
        "confirm": "Elimina ristorante",
        "message": "Are you sure you want to delete this restaurant?",
        "success": "Your restaurant has been deleted",
        "title": "You are about to delete a restaurant"
      },
      "delete-success": "Il tuo ristorante è stato cancellato",
      "edit": "Modifica le informazioni del ristorante",
      "save-success": "Il tuo ristorante è stato salvato",
      "seats": "Coperti",
      "title": "Informazioni sul ristorante",
      "type": {
        "(mountain) huts": "Rifugi",
        "american diner": "American diner",
        "american_diner": "American diner",
        "bar": "Birreria",
        "beach resorts": "Stabilimenti balneari",
        "beach_resorts": "Stabilimenti balneari",
        "bistro": "Bistro’",
        "camp sites": "Campeggi",
        "camp_sites": "Campeggi",
        "chicken restaurant": "Pollerie",
        "chicken_restaurant": "Pollerie",
        "fast food": "Fast food",
        "fast_food": "Fast food",
        "fish Burger": "Fish burger",
        "fish_burger": "Fish burger",
        "gourmet restaurant": "Ristorante gourmet",
        "gourmet_restaurant": "Ristorante gourmet",
        "grill restaurant": "Galletteria",
        "grill_restaurant": "Galletteria",
        "hamburger Restaurant": "Hamburgeria",
        "hamburger_restaurant": "Hamburgeria",
        "mountain_huts": "Rifugi",
        "other": "Altro",
        "pizza restaurant": "Pizzeria",
        "pizza_restaurant": "Pizzeria",
        "pub": "Pub",
        "seafood restaurant": "Ristorante di pesce",
        "seafood_restaurant": "Ristorante di pesce",
        "snack bar": "Tavola calda",
        "snack_bar": "Tavola calda",
        "steakhouse": "Ristoranti di carne"
      }
    },
    "title": "Profilo"
  },
  "registration": {
    "label": {
      "password": "Password",
      "restaurantName": "Please give the name of the restaurant for which you want to do the Menu Engineering calculation. [translate from EN]"
    },
    "placeholder": {
      "restaurantName": "Nome di ristorante"
    }
  },
  "updates-modal": {
    "general": {
      "close": "Chiudi"
    },
    "scopes": {
      "new-product-cold-store": {
        "button-text": "Aggiornamento! Nuove funzionalità.",
        "read-more": "Leggi di più",
        "title": "Aggiornamento! Nuove funzionalità.",
        "content": [
          {
            "title": "Gentile Cliente,",
            "content": "La informiamo di alcuni aggiornamenti al nostro Portale Clienti. Avrete ora la possibilità di visualizzare la vostra descrizione del prodotto e il vostro codice nel portale clienti. Nel caso in cui non vi risultasse un prodotto, vi preghiamo di contattare il vostro referente in Lamb Weston.",
            "image": "/img/updates/new-product-cold-store/it/1.jpg"
          },
          {
            "content": "Nel caso in cui voleste visualizzare i codici Lamb Weston, potete selezionare questa casella.",
            "image": "/img/updates/new-product-cold-store/it/2.jpg"
          },
          {
            "content": "Ora sarà visibile il luogo del deposito di carico.",
            "image": "/img/updates/new-product-cold-store/it/3.jpg"
          },
          {
            "content": "Per ulteriore assistenza vi preghiamo di contattare il vostro referente in Lamb Weston."
          }
        ]
      }
    }
  },
  "user-management": {
    "add": {
      "email": {
        "label": "Indirizzo email",
        "placeholder": "L'indirizzo email dell'utente…"
      },
      "error-message": "Si è verificato un errore durante l'aggiunta dell'utente",
      "intro": "Compila le informazioni qui sotto e fai clic sul pulsante aggiungi utente per aggiungere un nuovo utente.",
      "locale": {
        "label": "Lingua",
        "placeholder": "Seleziona la lingua preferita"
      },
      "mfa": {
        "phone": "Recapito telefonico",
        "title": "Preferenza di autenticazione multifattore",
        "use-sms-mfa": "SMS (ricevi un codice su dispositivo mobile)"
      },
      "sap-id": {
        "customer": "Cliente:",
        "label": "ID SAP",
        "no-portal-access": "Questo cliente non ha accesso al Portale Clienti.",
        "placeholder": "L'ID SAP è composto al massimo da 12 caratteri…",
        "unknown-sap-id": "ID SAP sconosciuto"
      },
      "success-message": "Utente aggiunto.",
      "user-group": {
        "label": "User group",
        "placeholder": "Seleziona gruppo utenti"
      }
    },
    "add-new-user": "Aggiungi nuovo utente",
    "change-roles": {
      "form": {
        "cancel": "Annulla",
        "error": "Non è stato possibile salvare i ruoli utente",
        "label": "Modifica ruolo/i",
        "placeholder": "Aggiungi un ruolo",
        "remove": "Rimuovi questo ruolo",
        "submit": "Salva",
        "success": "I ruoli utente sono stati salvati"
      }
    },
    "change-user-group": {
      "form": {
        "cancel": "Annulla",
        "error": "Il gruppo di utenti non può essere modificato",
        "group": {
          "administrators": "Amministratore",
          "any": "Qualsiasi",
          "direct-customers": "Cliente diretto",
          "end-users": "Utenti finali",
          "indirect-customers": "Cliente indiretto",
          "multinationals": "Multinazionale",
          "none": "Nessuno",
          "dock-scheduling-users": "Utente di pianificazione del dock",
          "dock-scheduling-employees": "Addetto alla pianificazione del porto"
        },
        "label": "Modifica gruppo di utenti",
        "submit": "Salva",
        "success": "Il gruppo di utenti è stato modificato"
      }
    },
    "column": {
      "customer": "Cliente",
      "details": "Modifica",
      "email": "Email",
      "first-name": "Nome",
      "last-name": "Cognome",
      "status": "Stato",
      "user-group": "User group",
      "vendor": "Partner"
    },
    "details": {
      "change-roles": "Modifica ruoli",
      "change-user-group": "Modifica gruppo di utenti",
      "impersonate": "Rappresenta questo utente",
      "language": "Lingua:",
      "manage-user-intro": "Puoi reimpostare la password di questo utente o l'autenticazione a due fattori facendo clic sui pulsanti qui sotto.",
      "manage-user-title": "Gestisci utente",
      "reset-mfa": "Reimposta 2FA",
      "reset-password": "Reimposta password",
      "sap-id": "ID SAP:",
      "sap-id-error": "Non è stato possibile cambiare l'ID SAP",
      "sap-id-placeholder": "Aggiungi ID SAP",
      "sap-id-success": "L'ID SAP è stato cambiato",
      "status": {
        "active": "Attivo",
        "inactive": "Inattivo"
      },
      "toggle-active-intro": "Tramite il toggle sottostante è possibile attivare o disattivare l'utente.",
      "toggle-active-title": "Attivare e disattivare l'utente"
    },
    "group": {
      "administrators": "Amministratori",
      "direct-customers": "Clienti diretti",
      "end-users": "Utenti finali",
      "indirect-customers": "Clienti indiretti",
      "dock-scheduling-users": "Utente di pianificazione del dock",
      "dock-scheduling-employees": "Addetto alla pianificazione del porto"
    },
    "group-short": {
      "administrators": "Admin",
      "any": "Qualsiasi",
      "direct-customers": "Cliente diretto",
      "end-users": "Utenti finali",
      "indirect-customers": "Cl. Indiretto",
      "multinational": "Multinazionale",
      "none": "Nessuno",
      "dock-scheduling-users": "Utente di pianificazione del dock",
      "dock-scheduling-employees": "Addetto alla pianificazione del porto"
    },
    "impersonate": {
      "bar": {
        "impersonating_as": "Stai attualmente rappresentando",
        "stop": "arresta rappresentazione"
      },
      "dialog": {
        "cancel": "Annulla",
        "confirm": "Impersona",
        "message": "Sei sicuro di voler impersonare \"{email}\"?",
        "title": "Impersona utente"
      }
    },
    "intro": "Gestisci gli utenti. Fai clic su una riga utente per maggiori informazioni o per possibili ulteriori azioni utente.",
    "reset-mfa": {
      "cancel": "Annulla",
      "confirm": "Conferma",
      "error": "Si è verificato un errore durante la reimpostazione dell'autenticazione a due fattori.",
      "message": "Reimpostare l'autenticazione a due fattori per questo utente?",
      "success": "L'autenticazione a due fattori è stata reimpostata.",
      "title": "Reimposta autenticazione a due fattori"
    },
    "reset-password": {
      "cancel": "Annulla",
      "confirm": "Conferma",
      "error": "Si è verificato un errore durante la reimpostazione della password.",
      "message": "Reimpostare la password per questo utente?",
      "success": "La password è stata reimpostata.",
      "title": "Reimposta password"
    },
    "search-bar": {
      "placeholder": {
        "all-user-groups": "All user groups",
        "search": "Cerca…",
        "search-alt": "cerca",
        "users": "Utenti"
      }
    },
    "status": {
      "active": "attivo",
      "cancel": "Annulla",
      "confirm": "Conferma",
      "inactive": "inattivo",
      "message": "Cambiare lo stato di questo utente?",
      "title": "Attivare e disattivare l'utente"
    },
    "title": "Gestione utente",
    "update-vendor-button": "Aggiorna partner",
    "vendor-label": "Partner",
    "vendor-tooltip": "Al momento non esiste un’integrazione diretta con il sistema SAP del fornitore. \nL'impostazione di un valore consente a un amministratore di creare prenotazioni per questo partner in base a questo valore.",
    "product-groups-label": "Gruppi di prodotti",
    "update-product-groups-button": "Aggiorna i gruppi di prodotti"
  },
  "validation": {
    "ext": "Sono accettati solo file con l'estensione '{ext}'.",
    "required": "Questo campo è obbligatorio",
    "totalSize": "Non è possibile caricare più di {totalSize}Mb",
    "quarterly": "I mesi selezionati non formano un trimestre valido",
    "no-special-characters": "L'input non può contenere hashtag, virgolette, asterischi o virgole.",
    "password": "La password deve contenere almeno {length} caratteri",
    "password-repeat": "Le password non corrispondono",
    "email": "Per favore, inserisci un indirizzo email valido",
    "max": "Questo campo deve contenere al massimo {max} caratteri.",
    "afterTime": "L'ora di fine deve essere successiva all'ora di inizio",
    "min": "Questo campo deve contenere almeno {min} caratteri."
  },
  "dock-management": {
    "dock-scheduler-title": "Programmatore del bacino",
    "select-location": "Posizione",
    "select-day": "Giorno",
    "dock-scheduler-no-data": "Seleziona una località e un giorno per visualizzare e prenotare una fascia oraria",
    "dock-schedule-table-cell-your-booking": "La tua prenotazione",
    "dock-schedule-table-cell-booked-by-other": "Prenotato",
    "dock-schedule-table-cell-closed": "Chiuso",
    "error-fetching-locations": "Impossibile recuperare le posizioni",
    "error-fetching-dock-schedule": "Impossibile recuperare la pianificazione",
    "docking-dialog": {
      "booking-id": "@:brand.name riferimento prenotazione",
      "license-plate": "Targa",
      "nationality": "Nazionalità",
      "remarks": "Osservazioni",
      "create-button": "Libro",
      "title": "Attracco per {dock} a {location}",
      "nationality-placeholder": "Scegli una nazionalità",
      "remarks-placeholder": "Ad esempio istruzioni di caricamento o commenti",
      "supplier-placeholder": "Ad esempio Lamb Weston",
      "license-plate-placeholder": "Ad esempio 22-BDS-02",
      "confirm-dialog": {
        "message": "Sei sicuro di voler rimuovere questa prenotazione? \nQuesto verrà eliminato per tutti."
      },
      "transporter": "Trasportatore",
      "booking-id-tooltip": "Numero dell'ordine in entrata/uscita o di acquisto.",
      "error-remove-booking-validation": "Non è consentita la cancellazione entro l'orario previsto. \nContatta il tuo referente all'indirizzo @:brand.name",
      "partner-placeholder": "Scegli un partner",
      "partner": "Per conto di"
    },
    "error-fetching-bookings": "Impossibile recuperare le prenotazioni",
    "success-creating-booking": "Fascia oraria prenotata con successo",
    "error-creating-booking": "Impossibile prenotare una fascia oraria",
    "success-deleting-booking": "Prenotazione cancellata con successo",
    "error-deleting-booking": "Impossibile eliminare una prenotazione",
    "success-updating-booking": "Prenotazione aggiornata con successo",
    "error-updating-booking": "Impossibile aggiornare una prenotazione",
    "dock-schedule-table-cell-no-longer-available": "Questa fascia oraria non è più disponibile perché non rientra nella finestra di prenotazione consentita.",
    "dock-schedule-table-cell-loading-reference-not-found": "Impossibile trovare il numero di riferimento",
    "dock-scheduler-closed-day": "La sede resterà chiusa per l'intera giornata.",
    "dock-schedule-table-lock-dock-tooltip": "Non puoi chiudere questo molo, perché ci sono già delle prenotazioni effettuate oggi",
    "error-unlocking-dock": "Impossibile sbloccare il dock",
    "error-locking-timeslot": "Impossibile bloccare il dock",
    "error-fetching-notifications": "Impossibile recuperare le notifiche",
    "location-notifications": {
      "confirm-dialog": {
        "message": "Sei sicuro di voler eliminare questa notifica?"
      },
      "add-notification": "Crea notifica"
    },
    "notification-dialog": {
      "title": "Notifica",
      "message": "Messaggio",
      "is-active": "È attivo"
    },
    "success-deleting-notification": "Notifica rimossa con successo",
    "error-deleting-notification": "Impossibile rimuovere la notifica",
    "success-creating-notification": "Creazione di una notifica riuscita",
    "error-creating-notification": "Impossibile creare una notifica",
    "success-updating-notification": "Notifica aggiornata con successo",
    "location-settings-dialog": {
      "title": "Impostazioni della sede",
      "cutoff-time": "Orario limite"
    },
    "success-updating-cutoff-time": "Orario limite aggiornato con successo",
    "error-updating-cutoff-time": "Impossibile aggiornare l'orario limite",
    "cutoff-time-label": "Le prenotazioni per il giorno successivo chiudono alle {time}",
    "error-updating-notification": "Impossibile aggiornare la notifica",
    "error-fetching-partners": "Impossibile recuperare i partner",
    "select-booking-period": "Periodo di prenotazione",
    "booking-overview-title": "Panoramica della prenotazione",
    "select-docks": "Banchine",
    "export-bookings-button": "Scaricamento",
    "export-bookings-subtitle": "File XLSX",
    "export-bookings-title": "Scarica le tue prenotazioni passate",
    "export-bookings-error": "Esportazione non riuscita",
    "booking-overview-table": {
      "date": "Data",
      "time": "Tempo",
      "location": "Posizione",
      "dock": "Dock",
      "reference-number": "Riferimento della prenotazione",
      "partner-id": "Socio esterno"
    },
    "dock-booking-overview-no-data": "Nessun dato",
    "dock-scheduling-rules-title": "Regole per la pianificazione delle banchine",
    "add-dock-scheduling-rule": "Nuova regola di pianificazione delle banchine",
    "schedule-overview-table": {
      "collapseTrigger": "{name} ({count} regole)",
      "no-data": "Nessuna regola è stata ancora creata."
    },
    "schedule-dialog": {
      "step-1-instructions": "Scegli una posizione, un molo e un gruppo di prodotti per creare una nuova regola",
      "title": "Regole per la pianificazione delle banchine",
      "step-2-location": "Posizione",
      "step-2-selected-docks": "Banchine",
      "step-2-selected-product-groups": "Gruppi di prodotti",
      "location": "Posizione",
      "docks": "Banchine",
      "product-groups": "Gruppi di prodotti"
    },
    "error-fetching-product-groups": "Impossibile ricevere i gruppi di prodotti",
    "error-updating-rule": "Impossibile aggiornare la regola",
    "success-updating-rule": "Regola aggiornata correttamente",
    "error-creating-rule": "Impossibile creare una regola",
    "success-creating-rule": "Regola creata correttamente",
    "error-deleting-rule": "Impossibile eliminare la regola",
    "success-deleting-rule": "Regola eliminata correttamente",
    "error-fetching-rules": "Impossibile ricevere le regole",
    "error-fetching-rule": "Impossibile ricevere le regole"
  },
  "days": {
    "monday": "Lunedì",
    "tuesday": "Martedì",
    "wednesday": "Mercoledì",
    "thursday": "Giovedì",
    "friday": "Venerdì",
    "saturday": "Sabato",
    "sunday": "Domenica"
  },
  "userMgtStore": {
    "userVendorUpdated": "Partner aggiornato correttamente",
    "userProductGroupUpdated": "Aggiornati i gruppi di prodotti con successo"
  },
  "captcha": {
    "error": "Si è verificato un errore nel controllo di sicurezza. Aggiornare la pagina e riprovare.",
    "title": "Verifica di sicurezza",
    "subtitle": "Completa la verifica qui sotto per continuare"
  }
}
